import { render, staticRenderFns } from "./viewinvoice.vue?vue&type=template&id=3163754c"
import script from "./viewinvoice.vue?vue&type=script&lang=js"
export * from "./viewinvoice.vue?vue&type=script&lang=js"
import style0 from "./viewinvoice.vue?vue&type=style&index=0&id=3163754c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports